import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { getOwner } from '@ember/application';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{!-- «UI nuova» switch (docs/ui-nuova/MIGRATION-PLAN.md §1.1): every user of an app that opted in with the\n     switch (owner 2026-10-22), see service:ui canChoose. Copy is still the Italian literal of the dev phase. --}}\n{{#if this.isVisible}}\n  <div class={{unless @compact \'box-white\'}} data-test-ui-toggle>\n    {{#if @compact}}\n      <span class=\'beebeeLabel\'>Grafica</span>\n    {{else}}\n      <h2 class=\'label hollow\'>Grafica</h2>\n    {{/if}}\n\n    <div class=\'bb-theme-toggle\'>\n      {{#each this.options as |opt|}}\n        <button\n          type=\'button\'\n          class=\'bb-theme-toggle__opt {{if (eq this.activeVersion opt.value) \"is-active\"}}\'\n          aria-pressed={{if (eq this.activeVersion opt.value) \'true\' \'false\'}}\n          data-test-ui-version={{opt.value}}\n          {{on \'click\' (fn this.choose opt.value)}}\n        >\n          {{opt.label}}\n        </button>\n      {{/each}}\n    </div>\n  </div>\n\n  <BbModalModern\n    @isOpen={{this.isConfirmOpen}}\n    @title=\'Modifiche non salvate\'\n    @size=\'medium\'\n    @onClose={{this.cancelSwitch}}\n    data-test-ui-toggle-dirty-modal\n  >\n    <:main>\n      <p>Hai modifiche non salvate: salvale o annullale prima di cambiare grafica.</p>\n    </:main>\n    <:footer>\n      <div class=\'button-group expanded\'>\n        <button\n          type=\'button\'\n          class=\'button large\'\n          data-test-ui-toggle-cancel\n          {{on \'click\' this.cancelSwitch}}\n        >\n          Annulla\n        </button>\n        <button\n          type=\'button\'\n          class=\'button large primary\'\n          data-test-ui-toggle-confirm\n          {{on \'click\' this.confirmSwitch}}\n        >\n          Cambia grafica\n        </button>\n      </div>\n    </:footer>\n  </BbModalModern>\n{{/if}}\n");

var _class, _descriptor;
let BbUiToggleComponent = (_class = class BbUiToggleComponent extends Component {
  constructor(...args) {
    super(...args);
    // Version the user asked for while the page had unsaved changes; non-null
    // keeps the confirm modal open.
    _initializerDefineProperty(this, "pendingVersion", _descriptor, this);
  }
  get ui() {
    return getOwner(this).lookup('service:ui') ?? null;
  }

  // Shown to every user of an app that opted in with the switch (owner 2026-10-22) — service:ui canChoose.
  get isVisible() {
    return Boolean(this.ui?.canChoose);
  }
  get activeVersion() {
    return this.ui?.isNuova ? 'nuova' : 'classica';
  }
  get options() {
    return [{
      value: 'classica',
      label: 'Grafica classica'
    }, {
      value: 'nuova',
      label: 'Grafica nuova'
    }];
  }
  get isConfirmOpen() {
    return this.pendingVersion !== null;
  }
  choose(value) {
    const ui = this.ui;
    if (!ui || value === this.activeVersion) {
      return;
    }
    if (ui.hasUnsavedChanges()) {
      this.pendingVersion = value;
      return;
    }
    ui.setVersion(value);
  }
  confirmSwitch() {
    const value = this.pendingVersion;
    this.pendingVersion = null;
    if (value !== null) {
      this.ui?.setVersion(value);
    }
  }
  cancelSwitch() {
    this.pendingVersion = null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "pendingVersion", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "choose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "choose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmSwitch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirmSwitch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelSwitch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelSwitch"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbUiToggleComponent);

export { BbUiToggleComponent as default };
//# sourceMappingURL=bb-ui-toggle.js.map
